import { render, staticRenderFns } from "./Survey.Question.RadioList.vue?vue&type=template&id=36dbbf5b&"
import script from "./Survey.Question.RadioList.vue?vue&type=script&lang=js&"
export * from "./Survey.Question.RadioList.vue?vue&type=script&lang=js&"
import style0 from "./Survey.Question.RadioList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol})
